import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'department_taxonomy',
  type: 'taxonomy_term--department',
  attributes: {
    uuid: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'uuid',
    },
    name: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'name',
    },
  },
  relationships: {},
};

export const TaxonomyDepartmentService = createService(base, configuration, API_CONFIG.API);
export const TaxonomyDepartmentModule = createModule(TaxonomyDepartmentService, true);



// WEBPACK FOOTER //
// ./src/models/taxonomyDepartment.js